module.exports = __webpack_public_path__ + "static/img/pic_szh_cgal_yq_bg.70cecfc7.png";